import React from 'react';
import { EntityClass } from '../../../../../types';
import {
  allSchemas,
  entityClassFromSchema,
  metaSchemas,
} from '../../../../util/properties';
import ClassTile from './ClassTile';

export interface ClassTilesProps {
  onSelectClass: (selectedClass: EntityClass, className: string) => void;
  disabled: boolean;
}

const ClassTiles = ({ onSelectClass, disabled }: ClassTilesProps) => {
  // Must wrap in a fragment to appease the typechecking gods
  return (
    <>
      {allSchemas().map((name: string, index: number) => {
        if (!metaSchemas().includes(name)) {
          return (
            <ClassTile
              key={index}
              name={name}
              classSchema={entityClassFromSchema(name)!}
              onSelect={onSelectClass}
              disabled={disabled}
            />
          );
        } else return null;
      })}
    </>
  );
};

export default ClassTiles;
